import React, { useRef } from 'react'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import {
    PageTitleText,FormContainer,PageLinkText,AuthBgContainer,FlexContainer
} from '../sign_in/sign_in.style';

import {
    AppInputField,InputFieldTitleText,AppInputFieldBtn
} from '../../../widget/styledComponents/input_field.style'
import { useParams} from 'react-router-dom';
import { gql, useMutation } from '@apollo/client';
import Cookies from 'js-cookie';
import { toaster } from 'evergreen-ui';




export const AUTH_LOGIN_VERIFY = gql`
mutation FacilityManager_login_verifyCode($token: String!, $code: String!) {
  facilityManager_login_verifyCode(token: $token, code: $code) {
    code
    success
    error
    data {
      _id
      email
      name
      phone
      photo
      managerType
      bankAccounts {
        _id
        accountNumber
        accountName
        bankCode
        bankName
        isPrimary
      }
      paymentModelType
      accessStartDate
      accessEndDate
      mostRecentAccessDuration
      createdAt
      id
    }
    token
  }
}
`;


function VerifySignInWidget() {
const history = useHistory()

const { id } = useParams();
const [verifyLogin, { loading }] = useMutation(AUTH_LOGIN_VERIFY);



const handleSubmit = (e)=>{
e.preventDefault();
verifyLogin({
    variables: { 
      code:codeRef.current.value,
      token:id
    },
  })
  .then((response) => {
    toaster.success("login verified")
    const res = response.data['facilityManager_login_verifyCode']
    Cookies.set('userAccessToken',`${res['token']}` );
    Cookies.set('userEmail',`${res['data']['email']}` );
    Cookies.set('userName',`${res['data']['name']}` );
    Cookies.set('banks',`${res['data']['bankAccounts']}` );
    Cookies.set('managerType',`${res['data']['managerType']}` );

    history.push(`/dashboard`);
  })
  .catch((error) => {
    toaster.dnager(error.message)
  });
};
const codeRef = useRef(null);

  return (
    <div className='row'>
        <AuthBgContainer className="col s12 m6 l6 hide-on-med-and-down"></AuthBgContainer>
        <div className='col s12 m6 l6 '>
            <div className='mt-100'></div>

            <form onSubmit={handleSubmit}>
                <FormContainer >
                    <PageTitleText>
                        Verify Login
                        <FlexContainer>
                          Check your email for the confirmation code.
                        </FlexContainer>
                    </PageTitleText>
                   
                    <br/><br/>
                    <br/><br/>
                
                    <InputFieldTitleText >
                        Confirmation Code
                    </InputFieldTitleText>
                    <AppInputField
                        type="text"
                        ref={codeRef} required
                    /> 
                    <div className='col s12'>
                        <PageLinkText className='right'>Resend Code</PageLinkText>
                    </div>

                    <AppInputFieldBtn 
                        className="mt-50" 
                        type='submit'
                        disabled={loading} 
                    >
                        {!loading && 'Verify' } 
                        {loading && 'Loading' }
                    </AppInputFieldBtn>
                    <FlexContainer>
                        Don’t have an account? <PageLinkText className='right' style={{
                            color:"var(--black, #4F46E5) !important",fontSize:"18px",
                            paddingLeft:"10px"
                        }} to="/signup">Sign Up</PageLinkText>
                    </FlexContainer>
                    

                </FormContainer>
            </form>

        </div>
    </div>
  )
}

export default VerifySignInWidget